import { Button, Stack, Typography } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

import _ from "lodash";

import SectionPreview from "../../../common/components/SectionPreview";
import { dateToStringShort, dateToStringLongSuffix } from "../../../common/utils/dateTime";
import { apiFileDownloadEndpoint } from "../../../common/components/mui-extended/DropzoneExtended";
import { CertificationPreviewDto, CertificationTZMode } from "../../../interfaces/Certification";
import { RegisterType } from "../../../common/interfaces/enums/RegisterType";

type CertificationProps = {
  model?: CertificationPreviewDto;
};

const Certification = ({ model }: CertificationProps) => {
  const renderNumberDate = (registrationNumber?: number, issueDate?: Date) => (
    <strong>{`${registrationNumber} / ${dateToStringShort(issueDate)}`}</strong>
  );

  const renderNotaryData = () => (
    <Typography>
      издадено от нотариус <strong>{model?.notary?.name}</strong>, номер{" "}
      <strong>{_.padStart(model?.notary?.number?.toString(), 3, "0")}</strong>, район на действие{" "}
      <strong>{model?.notary?.settlementName}.</strong>
    </Typography>
  );

  const renderCertificationData = () => {
    switch (model?.registerType) {
      case RegisterType.TZCertifications:
        switch (model?.certificationTZMode) {
          case CertificationTZMode.Signature:
            return (
              <>
                <Typography>
                  Удостоверяване на подпис по ТЗ{" "}
                  {renderNumberDate(model?.registrationNumberSignature, model?.issueDateSignature)}
                </Typography>
                {renderNotaryData()}
              </>
            );
          case CertificationTZMode.Content:
            return (
              <>
                <Typography>
                  Удостоверяване на съдържание по ТЗ{" "}
                  {renderNumberDate(model?.registrationNumberContent, model?.issueDateContent)}
                </Typography>
                {renderNotaryData()}
              </>
            );
          case CertificationTZMode.Both:
            return (
              <>
                <Typography>
                  Удостоверяване на подпис по ТЗ{" "}
                  {renderNumberDate(model?.registrationNumberSignature, model?.issueDateSignature)}
                </Typography>
                {renderNotaryData()}
                <br />
                <Typography>
                  Удостоверяване на съдържание по ТЗ{" "}
                  {renderNumberDate(model?.registrationNumberContent, model?.issueDateContent)}
                </Typography>
              </>
            );
          default:
            break;
        }
        break;
      case RegisterType.ZOZCertifications:
        return (
          <>
            Удостоверяване по ЗОЗ {renderNumberDate(model?.registrationNumberSignature, model?.issueDateSignature)}
            {renderNotaryData()}
          </>
        );
      default:
        break;
    }
  };

  const render = () => {
    return (
      <Stack spacing={3}>
        <Typography variant="subtitle2">
          Дата на въвеждане в регистъра: {dateToStringLongSuffix(model?.createDate)}
        </Typography>
        <SectionPreview title="Данни за удостоверяване">{renderCertificationData()}</SectionPreview>
        <SectionPreview title="Участници">{model?.participants}</SectionPreview>
        <SectionPreview title="Извлечение">{model?.statement}</SectionPreview>
        {model?.file?.blobId && (
          <SectionPreview title="Сканирано копие">
            <Button
              startIcon={<AttachFile />}
              variant="outlined"
              href={`${apiFileDownloadEndpoint}/${model?.file?.blobId}`}
            >
              {model?.file?.name}
            </Button>
          </SectionPreview>
        )}
      </Stack>
    );
  };

  return model ? render() : null;
};

export default Certification;
